import { AfterContentInit, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostMessageService } from '../../providers/postMessage.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: true,
})
export class CallbackComponent implements AfterContentInit {
  private activatedRoute = inject(ActivatedRoute);
  private postMessageService = inject(PostMessageService);

  eventName = '';

  constructor() {
    const evt = this.activatedRoute.snapshot.paramMap.get('event');
    if (evt != null) {
      this.eventName = evt;
    } else {
      const qpEvt = this.activatedRoute.snapshot.queryParamMap.get('event');
      if (qpEvt != null) {
        this.eventName = qpEvt;
      }
    }
  }

  ngAfterContentInit(): void {
    if (this.eventName) {
      this.postMessageService.postMessage(this.eventName);
    }
  }
}
